import { QueryFilter } from "src/app/shared/models/query-filter.model";
import { ScheduledBookingTypeEnum } from "src/app/shared/models/scheduled-booking-type.enum";

export class ScheduledBookingListQueryFilter extends QueryFilter {
    organizationId: string;
    timeZone: string;
    fromDate: Date;
    toDate: Date;
    scheduledBookingType: ScheduledBookingTypeEnum;
}
